import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class NotificationApiService {
  
  private apiUri = environment.uriG + "/api/notifications";
  
  constructor(private http:HttpClient) { }
  
  fetchUnreadNotificationCount(): Observable<any> {
    return this.http.get(`${this.apiUri}/unread-count`);
  }
}
